"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Discount;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Discount(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "discount"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M26,44.5A18.5,18.5,0,1,0,7.5,26,18.521,18.521,0,0,0,26,44.5Zm0-32A13.5,13.5,0,1,1,12.5,26,13.515,13.515,0,0,1,26,12.5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M74,55.5A18.5,18.5,0,1,0,92.5,74,18.521,18.521,0,0,0,74,55.5Zm0,32A13.5,13.5,0,1,1,87.5,74,13.515,13.515,0,0,1,74,87.5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M91.183,8.817a2.5,2.5,0,0,0-3.536,0L8.817,87.647a2.5,2.5,0,0,0,3.536,3.536l78.83-78.83A2.5,2.5,0,0,0,91.183,8.817Z"
  })))));
}